<p-drawer
  [(visible)]="layoutService.configSidebarVisible"
  position="right"
  [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
  styleClass="layout-config-sidebar w-80"
>
  <ng-template #header>
    <h3 class="m-0 font-semibold">Design konfigurieren</h3>
  </ng-template>

  <!-- Primary Color -->
  <section class="mb-6">
    <h4 class="mt-0 mb-3 font-medium text-sm">Primärfarbe</h4>
    <div class="flex flex-wrap gap-2">
      @for (color of primaryColors; track color.name) {
        <button
          class="theme-swatch"
          [style.background-color]="color.preview"
          [class.theme-swatch--active]="
            themeService.currentPrimary() === color.name
          "
          (click)="onPrimarySelect(color.name)"
          [title]="color.name"
          type="button"
        >
          @if (themeService.currentPrimary() === color.name) {
            <i class="pi pi-check text-white text-xs"></i>
          }
        </button>
      }
    </div>
  </section>

  <!-- Surface Color -->
  <section class="mb-6">
    <h4 class="mt-0 mb-3 font-medium text-sm">Oberflächenfarbe</h4>
    <div class="flex flex-wrap gap-2">
      @for (color of surfaceColors; track color.name) {
        <button
          class="theme-swatch"
          [style.background-color]="color.preview"
          [class.theme-swatch--active]="
            themeService.currentSurface() === color.name
          "
          (click)="onSurfaceSelect(color.name)"
          [title]="color.name"
          type="button"
        >
          @if (themeService.currentSurface() === color.name) {
            <i class="pi pi-check text-white text-xs"></i>
          }
        </button>
      }
    </div>
  </section>

  <!-- Preset -->
  <section>
    <h4 class="mt-0 mb-3 font-medium text-sm">Design</h4>
    <div class="flex flex-wrap gap-2">
      @for (preset of presetNames; track preset) {
        <p-button
          [label]="preset"
          [outlined]="themeService.currentPreset() !== preset"
          [severity]="
            themeService.currentPreset() === preset ? undefined : 'secondary'
          "
          size="small"
          (onClick)="onPresetSelect(preset)"
        />
      }
    </div>
  </section>
</p-drawer>
